export default __webpack_public_path__ + "static/media/minus-white.2332f173.svg";